import Vue from 'vue'

import elementUi from 'element-ui';
import { Message } from 'element-ui'
Vue.use(elementUi)

import App from './App.vue'
import {http} from "./http/http";
import router from "./router";
import store from './store'

import VueQuillEditor from 'vue-quill-editor'
// import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import './assets/css/iconfont.css'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
Vue.use(VueQuillEditor);

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
Vue.use(Antd)

import './assets/css/style.css'
import './assets/css/tailwind.css'

import mixin from './assets/js/mixin.js'
Vue.mixin(mixin)

Vue.prototype.$http = http
Vue.prototype.productionTip = false
Vue.prototype.$message = Message

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
